import sprint from 'sprint'
import _ from 'lodash'

import { LogEntry, LogLevel } from './types/log-entry'
import { config } from './types/config/config-shim'
import { aap, clientIdentity } from './types/helpers'

function sendError(entry: LogEntry): void {
  const client = _.assign(
    {
      code: clientIdentity.clientCode(),
      device: clientIdentity.deviceCode(),
    },
    config.clientDetails
  )
  if (window.device) {
    _.assign(client, {
      osVersion: window.device.version || '',
      model: window.device.model || '',
      manufacturer: window.device.manufacturer || '',
    })
  }
  entry = _.assign(
    {
      client,
      userAgent: navigator.userAgent,
    },
    entry
  )
  const url = '/api/client_error_report'
  const data = JSON.stringify(entry)

  if (!aap.beacon(url, data)) {
    aap.post(url, data, { timeout: 30 * 1000 })
  }
}

function report(
  level: LogLevel,
  obj: object,
  message?: string,
  args?: any[]
): void {
  const entry: LogEntry = { o: obj }
  if (level !== LogLevel.Info) {
    entry.l = level
  }
  if (message) {
    if (args && args.length > 0) {
      message = sprint(message, ...args)
    }
    entry.m = message
  }
  sendError(entry)
}

export default report
